module.exports = __webpack_public_path__ + "static/chilli-beans-3-eb511b5ccb4f0adc791bc06c0eb7c769.jpg";